<template>
  <div class="pagination-container">
    <el-pagination
      background
      layout="prev, pager, next, total"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="onChangePage"
      class="pagination">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      total: {
        type: Number,
        default: 0,
      },
      pageSize: {
        type: Number,
        default: 1,
      },
      currentPage: {
        type: Number,
      }
    },
    methods: {
      onChangePage(page) {
        this.$emit('update:currentPage', page);
        this.$emit('current-change', page);
      },
    }
  };
</script>

<style scoped>
  .pagination-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
</style>
